// extracted by mini-css-extract-plugin
export default {"sessionStartOuterCard":"StartSessionModal_sessionStartOuterCard__xsoG1"};